
import { Component, Prop, Vue, } from 'vue-property-decorator';

@Component
export default class ProgressSteps extends Vue {

	@Prop({
		type: Number,
		required: true,
		validator(value) {
			return typeof (value) === 'number' && value > 0;
		},
	})
	currentStep!: number;

	@Prop({
		type: Array,
		required: true,
	})
	progressStepsLabels!: string[];

	get totalSteps() {
		return Array.from({ length: this.progressStepsLabels.length, }, (step, index) => ({
			label: this.progressStepsLabels[index],
			index,
			step,
			isActiveStep: index + 1 === this.currentStep,
			isVisitedStep: index + 1 < this.currentStep,
		}));
	}
}
